export enum MunicipalitySelectorLayout {
  horizontal = 'horizontal',
  vertical = 'vertical',
}
